import { createApp } from 'vue'
import App from './App.vue'
import axios from '@/axios.js'

import '../common.js'

import '../vee-validate'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// Vuesax Component Framework
import Vuesax from 'vuesax3'
import { colors } from '../../themeConfig.js'

const token = localStorage.getItem('jwtoken')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

// vue full screen loading indicator
import { LoadingPlugin } from 'vue-loading-overlay'

// Perfect scrollbar
import PerfectScrollbar from 'vue3-perfect-scrollbar'

import VxTooltip from '../components/vx-tooltip/VxTooltip.vue'
import VxCard from '../components/vx-card/VxCard.vue'
import VxBreadcrumb from '../components/VxBreadcrumb.vue'
import VueFeather from 'vue-feather'
import VueSlider from 'vue-slider-component'

// Vuetify
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
const vuetify = createVuetify({
  components,
  directives,
})

// vee-validate component
import { Field, Form, ErrorMessage } from 'vee-validate'

// v-select component
import vSelect from 'vue-select'

const app = createApp(App)
app.config.globalProperties.$http = axios
app.use(router)
app.use(store)
app.use(vuetify)
app.use(Vuesax, {
  theme: {
    colors
  }
})
app.use(LoadingPlugin)
app.use(PerfectScrollbar, {
  options: {
    wheelPropagation: false,
    maxScrollbarLength: 60,
    wheelSpeed: 1,
    swipeEasing: true
  }
})
app.component(VxTooltip.name, VxTooltip)
app.component(VxCard.name, VxCard)
app.component(VxBreadcrumb.name, VxBreadcrumb)
app.component(VueFeather.name, VueFeather)
app.component('VueSlider', VueSlider)
app.component('ValidationForm', Form)
app.component('ValidationField', Field)
app.component('ValidationErrorMessage', ErrorMessage)
// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'x',
        svgClasses: 'w-4 h-4 mt-1'
      }
    })
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'chevron-down',
        svgClasses: 'w-5 h-5'
      }
    })
  }
})
app.component(vSelect)
app.mount('#app')
